export default "__VITE_ASSET__MWsleWje__"